/**
 * SGP result order on the website (Nov 4, 2026): exact combos priced live first, then the order a
 * typed request set on the server (`_requestRank`: "Curry points + Draymond rebounds", "safest",
 * "+500"), otherwise best EV first (`_sortEv`).
 */
export function compareSgpItems(a, b) {
  return (Number(!!b._exactCombo) - Number(!!a._exactCombo))
    || ((a._requestRank ?? Infinity) - (b._requestRank ?? Infinity))
    || ((b._sortEv ?? -999) - (a._sortEv ?? -999));
}
